import { h2ClassName } from '@/components/ui/styles';
import useProxyPoolCreationForm from '@/store/proxyPoolCreationFormStore';

export default function ProxyAmountInput() {
  const { quantity, setQuantity } = useProxyPoolCreationForm();

  return (
    <div className="mb-4">
      <h2 className={h2ClassName}>
        How many proxies do you want to generate right now?
      </h2>
      <div>
        <label
          htmlFor="proxyAmount"
          className="block text-sm font-medium leading-6 text-gray-900"
        >
          You can add more proxies in this proxy pool when needed.
        </label>
      </div>

      <div>
        <input
          className="py-1.5 px-3 border rounded text-sm text-gray-900"
          id="proxyAmount"
          type="number"
          min={1}
          max={999}
          value={quantity}
          onChange={(e) => setQuantity(Number(e.target.value))}
        />
      </div>
    </div>
  );
}
